import { useMutation } from "@tanstack/react-query";

import * as authApi from "../api";
import type { ResetPasswordEmailsData } from "../types";

export function useResetPasswordEmailMutation() {
  return useMutation({
    mutationFn: (payload: ResetPasswordEmailsData) =>
      authApi.resetPasswordEmails(payload),
  });
}
